/*
 * @Author: your name
 * @Date: 2021-04-26 10:50:12
 * @LastEditTime: 2022-02-28 11:05:53
 * @LastEditors: zhaozhuo
 * @Description: In User Settings Edit
 * @FilePath: \edc-mobile-web\src\utils\date.js
 */
/**
 * 时间戳转标准格式 2016-09-05 13:46:52
 * @returns {{_year: string, _month: string, _day: string, getYear: date.getYear, getMonth: date.getMonth, getDay: date.getDay}}
 */
function timestampFormat(str = new Date(), flag = 0) {
	const date = new Date(str)
	const yy = date.getFullYear()
	const mmmm = date.getMonth() + 1
	const dd = date.getDate()
	const h = date.getHours()
	const m = date.getMinutes()
	// const s = date.getSeconds()
	if (flag === 0) {
		return yy + '/' + (mmmm < 10 ? ('0' + mmmm) : mmmm)
	} else if (flag === 1) {
		return yy + '/' + (mmmm < 10 ? ('0' + mmmm) : mmmm) + '/' + (dd < 10 ? ('0' + dd) : dd)
	} else if (flag === 2) {
		// return yy + '-' + (mmmm < 10 ? ('0' + mmmm) : mmmm) + '-' + (dd < 10 ? ('0' + dd) : dd) + ' ' + (h < 10 ? ('0' + h) : h) + ':' + (m < 10 ? ('0' + m) : m) + ':' + (s < 10 ? ('0' + s) : s)
		return yy + '/' + (mmmm < 10 ? ('0' + mmmm) : mmmm) + '/' + (dd < 10 ? ('0' + dd) : dd) + ' ' + (h < 10 ? ('0' + h) : h) + ':' + (m < 10 ? ('0' + m) : m)
	}
}
// 获取当前年季度2010-1
function getQuarter(flag) {
	flag = flag || '-'
	const year = new Date().getFullYear()
	const month = new Date().getMonth() + 1
	const qurate = Math.ceil(month / 4)
	const date = `${year}${flag}${qurate}`
	return date
}
// 获取获取各种时间
function getTime(str) {
	const date = str ? new Date(str) : new Date()
	const year = date.getFullYear()
	const month = date.getMonth() + 1
	const day = date.getDate()
	const hour = date.getHours()
	const minute = date.getMinutes()
	const seconds = date.getSeconds()
	return { year, month, day, hour, minute, seconds }
}
/**
 * @description 格式化 时间
 * @param date 06/24/2016 12:14:25
 * @returns 2016-06-24 12:14:25
 */
function dateFormat(date) {
	const yy = date.getFullYear()
	const mmmm = date.getMonth() + 1
	const dd = date.getDate()
	const h = date.getHours()
	const m = date.getMinutes()
	const s = date.getSeconds()
	return yy + '-' + (mmmm < 10 ? ('0' + mmmm) : mmmm) + '-' + (dd < 10 ? ('0' + dd) : dd) + ' ' + (h < 10 ? ('0' + h) : h) + ':' + (m < 10 ? ('0' + m) : m) + ':' + (s < 10 ? ('0' + s) : s)
}
// 获取年份数据，用于自定义年份选择器
function getYearDatas(value) {
	let yearValue
	let yearIndex
	if (value !== undefined && value !== '') {
		yearValue = value
	} else {
		yearValue = new Date().getFullYear()
	}
	var yearDatas = []
	var startYear = new Date().getFullYear() - 100 // 起始年份
	var endYear = new Date().getFullYear() + 100 // 结束年份
	for (var i = startYear; i <= endYear; i++) {
		yearDatas.push(i)
		if (parseInt(yearValue) === i) {
			yearIndex = i - startYear
		}
	}
	return [
		{
			values: yearDatas,
			defaultIndex: yearIndex
		}
	]
}
// 获取时分秒数据，用于自定义时间选择器
function getTimeDatas(value) {
	let hourValue
	let minuteValue
	let secondValue
	let hourIndex
	let minuteIndex
	let secondIndex
	if (value !== undefined && value !== '' && value) {
		hourValue = value.split(':')[0]
		minuteValue = value.split(':')[1]
		secondValue = value.split(':')[2]
	} else {
		hourValue = new Date().getHours() < 10 ? '0' + new Date().getHours() : new Date().getHours()
		minuteValue = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes()
		secondValue = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds()
	}
	const hourDatas = []
	const minuteDatas = []
	const secondDatas = []
	for (let i = 0; i < 24; i++) {
		hourDatas.push(i < 10 ? '0' + i : i.toString())
		if (parseInt(hourValue) === i) {
			hourIndex = i
		}
	}
	for (let i = 0; i < 60; i++) {
		minuteDatas.push(i < 10 ? '0' + i : i.toString())
		if (parseInt(minuteValue) === i) {
			minuteIndex = i
		}
	}
	for (let i = 0; i < 60; i++) {
		secondDatas.push(i < 10 ? '0' + i : i.toString())
		if (parseInt(secondValue) === i) {
			secondIndex = i
		}
	}
	return [
		{
			values: hourDatas,
			defaultIndex: hourIndex
		},
		{
			values: minuteDatas,
			defaultIndex: minuteIndex
		},
		{
			values: secondDatas,
			defaultIndex: secondIndex
		}
	]
}
export { timestampFormat, getQuarter, getTime, dateFormat, getYearDatas, getTimeDatas }
